const side_nav = {
	administration: {
		budget: "Income/Expenses",
		discounts: "Discounts",
		invoices: "Invoices",
		orders: "Orders",
		quotes: "Quotes",
		title: "Administration",
	},
	customers: {
		debtor_groups: "Debtor groups",
		debtors: "Debtors",
		title: "Customers",
		users: "Users",
	},
	domains: {
		management: "Manage",
		register: "Register",
		title: "Domain Names",
	},
	management: {
		api_keys: "API keys",
		ip_blacklist: "IP blacklist",
		logs: "Logs",
		ns_groups: "Custom NS groups",
		staff: "Staff",
		title: "Management",
	},
	pbs: {
		management: "Management",
		register: "Create PBS",
		title: "Tuxis PBS",
	},
	products: {
		product_groups: "Product groups",
		products: "Products",
		title: "Products",
	},
	shared: {
		relations: "Relations",
	},
	vps: {
		create: "Create VPS",
		management: "Management",
		private_network: "Private networks",
		title: "Virtual private servers",
	},
};

export default side_nav;
